export default __webpack_public_path__ + "static/media/Layers.440b9414.png";